// eslint-disable-next-line ember/no-classic-components
import Component from '@ember/component';

/**
 * @param {String}              employeeName
 * @param {Boolean}             ccEmployee
 * @param {Boolean}             disabled
 */
export default class CcEmployee extends Component {}
